export default __webpack_public_path__ + "static/media/logoheadign.2fc50bfd.png";